import { List } from '@mui/material';
import { Clear, CompareArrows, Done } from '@mui/icons-material';
import { VerificarPermisos } from 'components/VerificarPermisos/VerificarPermisos';
import { PERMISOS } from 'const/Permisos';
import ListItemButtonComponent from 'components/design-system/ListItemButton/ListItemButton';
import { MenuItemComponente } from 'components/design-system/MenuItem/MenuItem';

// COMPONENTE SECUNDARIO
export const SimplePopper = props => {
  const {
    handleClickTerminarYAprobar,
    handleClickTerminarYRechazar,
    transaccion,
    titulo,
    rol
  } = props;
  return (
    <div className="w-full">
      <MenuItemComponente
        className="rounded-none bg-gray-100"
        nombre={titulo}
        collapsable={true}
        icono={<CompareArrows className="text-uv-primary-0" />}
        subItems={
          <List className="my-0 py-0">
            <VerificarPermisos nombrePermiso={PERMISOS.cerrarTransaccion}>
              <ListItemButtonComponent
                type="secondary"
                onClick={e => handleClickTerminarYAprobar(e, transaccion, rol)}
                icon={<Done className="text-success-dark" />}
                label={<span className="text-success-dark">Aprobar</span>}
              />
            </VerificarPermisos>
            <VerificarPermisos nombrePermiso={PERMISOS.cerrarTransaccion}>
              <ListItemButtonComponent
                type="secondary"
                onClick={e => handleClickTerminarYRechazar(e, transaccion, rol)}
                icon={<Clear className="text-error-dark" />}
                label={<span className="text-error-dark">Rechazar</span>}
              />
            </VerificarPermisos>
          </List>
        }
      />
    </div>
  );
};
